module.exports = __webpack_public_path__ + "static/media/siprc_dots.834787d3.png";